// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"c54f1b22","840":"19cf2919"}[chunkId] + ".chunk.css";
};